import { render } from "./EmployeeCreate.vue?vue&type=template&id=65bf6432&scoped=true"
import script from "./EmployeeCreate.vue?vue&type=script&lang=js"
export * from "./EmployeeCreate.vue?vue&type=script&lang=js"

import "./EmployeeCreate.vue?vue&type=style&index=0&id=65bf6432&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65bf6432"]])

export default __exports__